import { useSubmitPasswordMutation } from '@twisto/api-graphql'
import type { CastedSubmitHandler } from '@twisto/components/atoms/form'
import { useForm } from '@twisto/components/atoms/form'
import { useResponseErrors } from '@twisto/form'

import { FlowForm } from '../../components'
import { useFlow } from '../../flow/flow.context'
import { PasswordStepHeadline } from '../password-step/password-step-headline'

import type { PasswordFormValues } from './password-step-form-content'
import {
  PasswordStepFormContent,
  passwordFieldName,
} from './password-step-form-content'

export const PasswordStep = () => {
  const formContext = useForm({
    defaultValues: {
      [passwordFieldName]: '',
    },
  })
  const { sessionId } = useFlow<'PasswordStep'>()
  const [submitPassword, { data }] = useSubmitPasswordMutation()

  useResponseErrors(data?.submitPassword, formContext)

  const handleSubmit: CastedSubmitHandler<PasswordFormValues> = async ({
    password,
  }: PasswordFormValues) => {
    submitPassword({ variables: { password, auth: { sessionId } } })
  }

  return (
    <>
      <PasswordStepHeadline />

      <FlowForm {...formContext} onSubmit={handleSubmit}>
        <PasswordStepFormContent />
      </FlowForm>
    </>
  )
}
